import { Box } from "@chakra-ui/react";
import { RefObject, useEffect, useState } from "react";
import ReactConfetti from "react-confetti";

export const Confetti = ({
  showConfetti,
  setShowConfetti,
  containerRef,
  numberOfPieces,
}: {
  showConfetti: boolean;
  setShowConfetti: (show: boolean) => void;
  containerRef?: RefObject<HTMLDivElement | null>;
  numberOfPieces?: number;
}) => {
  const [confettiDimensions, setConfettiDimensions] = useState({
    width: 0,
    height: 0,
  });
  const isFullscreen = !containerRef;

  useEffect(() => {
    if (!showConfetti) return;

    const update = () => {
      if (containerRef?.current) {
        const el = containerRef.current;
        setConfettiDimensions({ width: el?.offsetWidth ?? 0, height: el?.offsetHeight ?? 0 });
      } else if (typeof window !== "undefined") {
        setConfettiDimensions({ width: window.innerWidth, height: window.innerHeight });
      }
    };

    update();

    // Use ResizeObserver when targeting a container; otherwise listen to window
    let ro: ResizeObserver | null = null;
    if (containerRef?.current && "ResizeObserver" in window) {
      ro = new ResizeObserver(update);
      ro.observe(containerRef.current!);
    } else if (typeof window !== "undefined") {
      window.addEventListener("resize", update);
      window.addEventListener("orientationchange", update);
    }

    return () => {
      ro?.disconnect();
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", update);
        window.removeEventListener("orientationchange", update);
      }
    };
  }, [showConfetti, containerRef]);

  if (!showConfetti) return null;
  return (
    <Box
      position={isFullscreen ? "fixed" : "absolute"}
      top={0}
      left={0}
      width="full"
      height="full"
      pointerEvents="none"
      zIndex={9999}
    >
      <ReactConfetti
        width={confettiDimensions.width}
        height={confettiDimensions.height}
        recycle={false}
        numberOfPieces={numberOfPieces ?? 200}
        gravity={0.3}
        initialVelocityY={20}
        colors={["#FFD700", "#FFA500", "#FF69B4", "#9370DB"]}
        onConfettiComplete={() => {
          setTimeout(() => setShowConfetti(false), 3000);
        }}
      />
    </Box>
  );
};
